export default {
    init() {
        this.modal = $('.promo-modal-wrapper');
        if (this.modal.length < 1) return;
        this.modalID = this.modal.data('promo-id');
        window.dataLayer = window.dataLayer || [];
        this.triggered = false;
        this.exitTriggered = false;
        this.scrollLimit = ($(document).height() - window.innerHeight / 2) * .25;
        this.timoutLength = 20 * 1000;
        this.bindEvents();

    },

    open() {
        window.dataLayer.push({'event': 'promoModal-open', 'promoModalId': this.modalID});
        this.modal.removeClass('full-close');
        this.modal.removeClass('tab-close');
    },

    show() {
        window.dataLayer.push({'event': 'promoModal-shown', 'promoModalId': this.modalID});
        this.modal.removeClass('full-close');
        this.modal.removeClass('tab-close');
    },

    closeToTab() {
        window.dataLayer.push({'event': 'promoModal-close', 'promoModalId': this.modalID});
        this.modal.removeClass('full-close');
        this.modal.addClass('tab-close');
    },

    isExitDetected(event) {
        if (this.exitTriggered) return;
        if (event.relatedTarget !== null || event.clientY > 10) return;
        this.show();
        this.exitTriggered = true;
        this.triggered = true;
    },

    isScrollDetected() {
        if (this.triggered) return;
        if (window.scrollY < this.scrollLimit) return;
        this.triggered = true;
        this.show();
    },

    onTimeout() {
        if (this.triggered) return;
        this.triggered = true;
        this.show();
    },

    bindEvents() {
        $(document).on('mouseleave', (e) => this.isExitDetected(e));
        $(window).on('scroll', () => this.isScrollDetected());
        setTimeout(() => this.onTimeout(), this.timoutLength);

        this.modal.find('.close-toggle').on('click', (e) => {
            e.stopPropagation();
            this.closeToTab();
        });

        this.modal.find('.promo-modal').on('click', () => {
            if (!this.modal.hasClass('tab-close')) return;
            this.open();
        });
        this.modal.on('click', () => this.closeToTab())
            .children().on('click', (e) => e.stopPropagation());
    },
};